module.exports = __webpack_public_path__ + "static/media/Faun.3d555777.jpg";